export const version = "1.0.2-daily-20260508-0";
export const channel = "daily";
export const gitcommit = "46618fce6";
